<template>
  <!--清除缓存-->
  <div id="allRemove"></div>
</template>

<script>
export default {
  name: 'allRemove',
  data () {
    return {}
  },
  created () {
    window.localStorage.removeItem('TaToken')
    window.localStorage.removeItem('appId')
    window.localStorage.removeItem('openId')
    window.localStorage.removeItem('isEmployee')
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/allRemove.vue